import React from 'react'
import "./AttestationBloreCert.css"
import AttestationBloreCertMain from './AttestationBloreCertMain'

const AttestationBloreCert = () => {
  return (
    <div className='atteBloreCertContainer' >
      <AttestationBloreCertMain/>
    </div>
  )
}

export default AttestationBloreCert
